import { Controller, Menu, Toolbar } from '@tencent/workbench';
import { MoveUpFeature } from './move-up-feature';
import { INSERT_TEXT_MENU_CONFIGS, config, MOVE_UP } from './config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { Form } from '@tencent/wb-ext-form';
import { FORM_CONFIGS_MOVE_UP } from '@framework/workbench/drawer/ui/layout/layer/config';
import { wrapIdForCommon, wrapIdForPic, wrapIdForText } from '@src/framework/workbench/util/wrap-id-util';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    formItems: FORM_CONFIGS_MOVE_UP,
    toolbarItems: MOVE_UP,
})
export class MoveUpController {
    constructor(private readonly feature: MoveUpFeature) {
    }

    @Menu(config.id, 'onClick')
    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForCommon(config.id), 'onClick')
    @Menu(ActionType.MOVE_ITEM_UP, 'onClick')
    public onClick() {
        this.feature.callback();
    }

    @Form(config.id, 'onClick')
    public onDrawerClick() {
        this.feature.drawerCallback();
    }
}
